/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PropertyColumns {
    LAT = 'lat',
    LON = 'lon',
    STREET_ADDRESS = 'street_address',
    BUILDING_NAME = 'building_name',
    NUMBER_UNITS = 'number_units',
    YEAR_BUILT = 'year_built',
    NUMBER_STORIES = 'number_stories',
    NUMBER_STORIES_PREDICTION = 'number_stories_prediction',
    MANAGEMENT_COMPANY = 'management_company',
    BUILDING_WEBSITE = 'building_website',
    PROPERTY_ID = 'property_id',
    IS_APARTMENT = 'is_apartment',
    IS_CONDO = 'is_condo',
    IS_SINGLE_FAMILY = 'is_single_family',
    IS_STUDENT = 'is_student',
    IS_SENIOR = 'is_senior',
    IS_BUILD_TO_RENT = 'is_build_to_rent',
    IS_AFFORDABLE = 'is_affordable',
    CATS_MONTHLY_RENT = 'cats_monthly_rent',
    CATS_ONE_TIME_FEE = 'cats_one_time_fee',
    CATS_DEPOSIT = 'cats_deposit',
    DOGS_MONTHLY_RENT = 'dogs_monthly_rent',
    DOGS_ONE_TIME_FEE = 'dogs_one_time_fee',
    DOGS_DEPOSIT = 'dogs_deposit',
    ADMIN_FEE = 'admin_fee',
    AMENITY_FEE = 'amenity_fee',
    APPLICATION_FEE = 'application_fee',
    STORAGE_FEE = 'storage_fee',
    PARKING_COVERED = 'parking_covered',
    PARKING_GARAGE = 'parking_garage',
    PARKING_SURFACE_LOT = 'parking_surface_lot',
    BUILDING_AMENITIES = 'building_amenities',
    UNIT_AMENITIES = 'unit_amenities',
    OVERALL_QUALITY_SCORE = 'overall_quality_score',
    QUALITY_SCORE_BEDROOM = 'quality_score_bedroom',
    QUALITY_SCORE_KITCHEN = 'quality_score_kitchen',
    QUALITY_SCORE_BATHROOM = 'quality_score_bathroom',
    QUALITY_SCORE_DINING_ROOM = 'quality_score_dining_room',
    QUALITY_SCORE_COMMON_AREAS = 'quality_score_common_areas',
    QUALITY_SCORE_FITNESS_CENTER = 'quality_score_fitness_center',
    QUALITY_SCORE_LAUNDRY_ROOM = 'quality_score_laundry_room',
    QUALITY_SCORE_LIVING_ROOM = 'quality_score_living_room',
    QUALITY_SCORE_MAIN_ENTRANCE = 'quality_score_main_entrance',
    QUALITY_SCORE_STAIRS_HALLWAY = 'quality_score_stairs_hallway',
    QUALITY_SCORE_SWIMMING_POOL = 'quality_score_swimming_pool',
    QUALITY_SCORE_WALK_IN_CLOSET = 'quality_score_walk_in_closet',
    AVG_DURATION_DAYS = 'avg_duration_days',
    AVG_PRICE_CHANGE = 'avg_price_change',
    AVG_TIME_ON_MARKET_DAYS = 'avg_time_on_market_days',
    COUNT_PRICES = 'count_prices',
    IS_USING_REV_MANAGEMENT = 'is_using_rev_management',
    COUNT_REVIEWS = 'count_reviews',
    AVG_REVIEW_SCORE = 'avg_review_score',
    IS_LEASE_UP = 'is_lease_up',
    POSITIVE_STAFF_AND_MANAGEMENT = 'positive_staff_and_management',
    POSITIVE_AMENITIES_AND_FEATURES = 'positive_amenities_and_features',
    POSITIVE_CLEANLINESS_AND_MAINTENANCE = 'positive_cleanliness_and_maintenance',
    POSITIVE_LOCATION = 'positive_location',
    POSITIVE_VALUE = 'positive_value',
    NEGATIVE_STAFF_AND_MANAGEMENT = 'negative_staff_and_management',
    NEGATIVE_AMENITIES_AND_FEATURES = 'negative_amenities_and_features',
    NEGATIVE_CLEANLINESS_AND_MAINTENANCE = 'negative_cleanliness_and_maintenance',
    NEGATIVE_LOCATION = 'negative_location',
    NEGATIVE_VALUE = 'negative_value',
}
